export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1653_.65050ef1.jpg";